 export enum SlotBookingStatus {
    LISTED='LISTED',
    ON_CONFIRM = 'ON_CONFIRM',
    ON_REQUEST= 'ON_REQUEST',
    CONFIRMED='CONFIRMED', 
    DENIED='DENIED'    
}


